import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [CreditCardTypes, CreditCardTypeSchema] = EnumBuilder(
  'amex',
  'diners',
  'discover',
  'eftpos_au',
  'jcb',
  'link',
  'mastercard',
  'unionpay',
  'visa',
  'unknown'
)

export type CreditCardType = ZodInfer<typeof CreditCardTypeSchema>
